import React, { useState } from "react";
import moment from "moment";
import { PreviewLetterLogo, PreviewLetterContainer } from "../../../RecommendGrant/Component/ViewEditSchedules/style";
import { UnderlyingContent } from "../../../RecommendGrant/style";
import { grantLetterFormatMap, getNameWithSalutation } from "../../../RecommendGrant/utils";
import previewLetter from "../../../../../../assets/icons/preview-letter.svg";
import GrantPaymentLetter from "../GrantPaymentLetter/GrantPaymentLetter";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";
import { getPrimaryAccount } from "../../../../../../utils/sessionUtil";
import { PreviewLetterContent } from "../ReviewAndSubmit/Components/styles";
import { LogoWrap } from "../../styles";

const PreviewLetter = ({
    charityName,
    charityAddress,
    startDate,
    grantAmount,
    grantPurposeName,
    additionalComments,
    notifyFirstName,
    notifyLastName,
    inMemoryOfName,
    inHonorOfName,
    thirdParty,
    includeAdvisorInfo,
    grantRecognition,
    advisors = [],
    publishPermission,
    codeValueMappingData,
    projectName
}) => {
    const [previewVisible, showPreview] = useState(false);
    const { accountName, userId: accountId } = getPrimaryAccount();
    const grantData = {
        granteeOrg: {
            name: charityName,
            ...charityAddress
        },
        dateofPayment: startDate ? moment(startDate).valueOf() : undefined,
        grantAmount: grantAmount,
        grantFrom: getPrimaryAccount().accountName,
        primaryAdvisor: [],
        purpose: {
            purpose: grantPurposeName,
            description: grantPurposeName,
            additionalComments: additionalComments
        },
        projectName: projectName,
        hideAdvisorInfo: !includeAdvisorInfo,
        thirdPartyDetails: thirdParty,
        grantRecognition: {
            grantRecognition: grantLetterFormatMap[grantRecognition], // Map from recognition id
            accountName,
            notifyFirstName,
            notifyLastName,
            inMemoryOfName,
            inHonorOfName,
            grantNotes: thirdParty,
        },
        publishPermission: publishPermission,
    };

  advisors.map(({ firstName, middleName, lastName, addresses = [], title, suffix }) => {
    const address = addresses.length ? addresses[0] : undefined;
    if (codeValueMappingData && codeValueMappingData.title && codeValueMappingData.title.length) {
      grantData.primaryAdvisor.push({
        name: getNameWithSalutation(firstName, middleName, lastName, codeValueMappingData, title, suffix),
        ...address
      });
    }
  });

  return (
    <>
      {!advisors && <Preloader />}
      {advisors
        && <>
          <PreviewLetterContainer flexCenter>
            <LogoWrap>
              <PreviewLetterLogo src={previewLetter} alt="preview-letter" />
            </LogoWrap>
            <PreviewLetterContainer>
              <PreviewLetterContent>{"To preview the grant agreement letter we'll send to the grantee organization, "}
                <UnderlyingContent id="anrgrantAgreementLetter" onClick={() => showPreview(true)}>click here</UnderlyingContent>
                <span>.</span>
              </PreviewLetterContent>
            </PreviewLetterContainer>
          </PreviewLetterContainer>
          <GrantPaymentLetter visible={previewVisible} onCancel={() => showPreview(false)} grantData={grantData}></GrantPaymentLetter>
          </>}
    </>);
};

export default PreviewLetter;